<template>
  <div>
    <v-card>
      <div v-padding="3">
        <div>
          Вы можете использовать данные оценки благонадежности физических лиц и
          ИП внутри любой вашей учетной системы через интеграцию с Unirate API.
          Такая интеграция существенно ускоряет бизнес-процессы, избавляет
          пользователей от рутины, необходимости переключаться между окнами и
          снижает риски ошибок связанных с человеческим фактором.
        </div>

        <div v-margin.top="2">
          Например, вы можете внедрить автоматические проверки в следующих
          сценариях:
          <ul>
            <li>
              Проверка кандидатов устраивающихся на материально-ответственные
              должности или массовые профессии.
            </li>
            <li>
              Проверка Индивидуальных предпринимателей перед предоставлением
              отсрочки платежа.
            </li>
          </ul>
        </div>

        <div v-margin.top="2">Преимущества использования Unirate API:</div>
        <div v-margin.top="2" :class="theme.integrationTableWrap">
          <table :class="theme.integrationTable">
            <thead></thead>
            <tbody>
              <tr>
                <td>Повышение скорости принятия решения.</td>
                <td>
                  За счет интеграции проверки непосредственно в вашу учетную
                  систему.
                </td>
              </tr>
              <tr>
                <td>Снижение финансовых рисков.</td>
                <td>
                  За счет снижения рисков человеческих ошибок и экономии на
                  разработке собственных сервисов.
                </td>
              </tr>
              <tr>
                <td>Автоматизация проверки.</td>
                <td>
                  Проверка выполняется одной кнопкой или вообще без кнопки,
                  бесшовно встраиваясь в ваш рабочий процесс.
                </td>
              </tr>
              <tr>
                <td>Быстрая проверка большого объема данных.</td>
                <td>
                  Больше не нужно вводить данные каждого кандидата в веб-форму.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <img
          :src="require('./integration.png')"
          :class="theme.integrationImage"
        />

        <div v-margin.top="2">
          Unirate предоставляет API интерфейсы на базе RESTful и JSON. С их
          помощью доступ функциям проверки ФЛ и ИП может получить любое
          приложение без использования веб-интерфейса, что позволяет реализовать
          процесс проверки внутри "единого окна".
        </div>
        <div v-margin.top="2">
          Свяжитесь с нами, чтобы получить более подробную информацию о ценах и
          вариантах использования Unirate API.
        </div>
        <div v-text-align.left v-margin.top="2">
          <v-button primary @click="requestIntegration">
            Оставить заявку
          </v-button>
        </div>
      </div>
    </v-card>
    <v-modal :active="isShowConfirm" @close="isShowConfirm = false">
      <div v-padding="2">
        <div v-margin.bottom="1">
          <v-text type="title" v-margin.bottom="2"> Спасибо </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text type="title" v-margin.bottom="2">
            Ваша заявка принята
          </v-text>
        </div>

        <div v-margin.bottom="1">
          <v-text v-margin.bottom="2">
            Мы свяжемся с вами в ближайшее время.
          </v-text>
        </div>

        <div v-text-align.right v-margin.top="1">
          <v-button flat @click="close"> Закрыть </v-button>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>
import Tabs from "../../../baseComponents/components/Tabs/Tabs.vue";
import { requestIntegration } from "../../../services/api/profile";
import theme from "./theme.scss";
export default {
  components: { Tabs },
  name: "integration",
  props: {
    theme: {
      type: Object,
      default() {
        return theme;
      },
    },
  },
  data() {
    return {
      isShowConfirm: false,
    };
  },
  methods: {
    requestIntegration() {
      requestIntegration().then(() => {
        this.isShowConfirm = true;
      });
    },
    close() {
      this.isShowConfirm = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// Integration.vue?3c2fa7fc